import { useQuery } from '@tanstack/react-query';

import type { EmailBasicDto } from '@/api/generated';

import { useEmailApiClient } from '@/api/clients/useEmailApiClient.util.ts';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useUserContext } from '@/contexts/userContext/User.context.ts';

type Req = {
  emailId: string;
  isEnabled: boolean;
};

type Response = EmailBasicDto;

type Return = {
  email: Response | undefined;
  isFetching: boolean;
  isPending: boolean;
};

export const useReadEmail = (req: Req): Return => {
  const { emailReaderApi } = useEmailApiClient();
  const { userId } = useUserContext();

  const { data, isFetching, isPending } = useQuery<Response>({
    enabled: req.isEnabled,
    queryFn: async () => {
      const { data } = await emailReaderApi.readEmail(userId, req.emailId);
      return data;
    },
    queryKey: [QueryKeyEnum.EMAILS.READ, req.emailId],
  });

  return {
    email: data,
    isFetching,
    isPending,
  };
};
